import type { ReactNode } from 'react'

import DefaultPending from '@/components/DefaultPending'
import StripeConnectPaintedSurface from '@/components/stripe-connect/StripeConnectPaintedSurface'
import StripeConnectNotificationBannerPlaceholder, {
  STRIPE_CONNECT_NOTIFICATION_BANNER_MIN_HEIGHT_CLASS,
} from '@/components/stripe-connect/StripeConnectNotificationBannerPlaceholder'
import StripeConnectSection from '@/components/stripe-connect/StripeConnectSection'
import { cn } from '@/lib/utils'

function StripeConnectRoutePending({ className = '' }: { className?: string }) {
  return <DefaultPending className={className} />
}

export function StripeConnectDeferredRouteContent({
  isReady,
  children,
  pendingClassName = '',
}: {
  isReady?: boolean
  children?: ReactNode
  pendingClassName?: string
}) {
  return (
    <div className="relative">
      {!isReady ? <StripeConnectRoutePending className={pendingClassName} /> : null}

      <div className={cn(!isReady && 'pointer-events-none absolute inset-0 opacity-0')}>
        {children}
      </div>
    </div>
  )
}

export function StripeConnectBannerFallback({
  title = 'Stripe Account Alerts',
  description = 'Review important Stripe updates before they interrupt payouts or payments.',
  showSectionCard = true,
  showSectionHeader = true,
  panelClassName,
}: {
  title?: ReactNode
  description?: ReactNode
  showSectionCard?: boolean
  showSectionHeader?: boolean
  panelClassName?: string
}) {
  return (
    <div className={panelClassName}>
      <StripeConnectSection
        title={title}
        description={description}
        showCardShell={showSectionCard}
        showHeader={showSectionHeader}
      >
        <StripeConnectPaintedSurface
          className="overflow-hidden"
          minHeightClassName={STRIPE_CONNECT_NOTIFICATION_BANNER_MIN_HEIGHT_CLASS}
          placeholder={<StripeConnectNotificationBannerPlaceholder />}
          showPlaceholder
        />
      </StripeConnectSection>
    </div>
  )
}
